const DEFAULT_SETTINGS = {
  type: "mentions",
  mentionTrigger: "@",
  getMentionLink: () => "#",
  visibleItemsBeforeOverflow: 5,
  onMentionClick: void 0,
  getMentions: (searchQuery) => new Promise(
    (resolve) => setTimeout(
      () => resolve(
        [
          { name: "Test One", slug: "testone" },
          { name: "Test One.1", slug: "testone1" },
          { name: "Test One.2", slug: "testone2" },
          { name: "Test One.3", slug: "testone3" },
          { name: "Test One.4", slug: "testone4" },
          { name: "Test One.5" },
          { name: "Test One.6" },
          { name: "Test One.7" },
          { name: "Test One.8" },
          {
            name: "Test Two",
            avatar: "https://via.placeholder.com/100x100?text=Image=50"
          },
          { name: "Everyone", slug: "everyone", type: "group" }
        ].filter(({ name }) => name.toLowerCase().includes(searchQuery.toLowerCase()))
      ),
      250
    )
  ),
  zIndex: 9999
};
const DEFAULTS = {
  config: { ...DEFAULT_SETTINGS }
};
export {
  DEFAULTS
};
//# sourceMappingURL=default-settings.js.map
